// extracted by mini-css-extract-plugin
export default {"formWrapperDesktop":"aNpIGM","formWrapperShadow":"bNpIGM"};